import React, { ReactNode, useContext } from "react";
import { XPSystem } from "../classes/XPSytem";
import { XPSystemContext } from "../contexts/XPSystemContext";
import XPItem from "./XPItem";

export default () => {
  const xpSystem: XPSystem = useContext(XPSystemContext);
  const xpModules: ReactNode[] = xpSystem.xpModules.map((xpModule) => {
    return <XPItem key={`${xpModule.key}`} xpModule={xpModule} />;
  });
  return <div style={{ display: "flex", flexWrap: "wrap" }}>{xpModules}</div>;
};
